import { CATEGORY_IDS } from 'constants/categories'
import { useService } from 'services/utils/context'

export const useCategoryLinks = () => {
  const service = useService()

  return [
    {
      title: service.categories.getById(CATEGORY_IDS.female.root)?.name,
      link: service.categories.getById(CATEGORY_IDS.female.bekleidung)?.url,
    },
    {
      title: service.categories.getById(CATEGORY_IDS.male.root)?.name,
      link: service.categories.getById(CATEGORY_IDS.male.bekleidung)?.url,
    },
    {
      title: service.categories.getById(CATEGORY_IDS.kids.root)?.name,
      link: service.categories.getById(CATEGORY_IDS.kids.root)?.url,
    },
  ].filter(categoryLink => categoryLink.link && categoryLink.title)
}
